/**
 * @file コンポーネント：フル動画ページポイントコンテンツ スタイル管理
 */

// ライブラリ読み込み
import styled from "styled-components";

// スタイル
export const StyledContent = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    padding: 8px 8px 12px;
    overflow-y: auto;
`;

export const StyledContentHeadline = styled.h3`
    margin-bottom: 8px;
    color: #ffffff;
    font-weight: bold;
    font-size: 12px;
    line-height: 14px;
`;

export const StyledContentParagraph = styled.p`
    margin-bottom: 8px;
    color: #ffffff;
    font-size: 12px;
    line-height: 14px;

    &:last-child {
        margin-bottom: 0;
    }
`;

export const StyledContentSection = styled.section`
    margin-bottom: 16px;
    padding-bottom: 16px;
    border-bottom: 1px solid #acadae;

    &:last-of-type {
        margin-bottom: 0;
        padding-bottom: 0;
        border-bottom: none;
    }
`;

export const StyledContentSectionContainer = styled.div`
    display: flex;
`;

export const StyledContentSlider = styled.div`
    flex: 2;
    margin-right: 16px;
`;

export const StyledContentSliderImage = styled.img`
    width: 100%;
`;

export const StyledContentText = styled.div`
    flex: 3;
`;

export const StyledContentTextLink = styled.div`
    margin-top: 16px;
    text-align: right;
`;
